import React, {useState, useContext} from 'react';
import AddToDoListView from './AddToDoListView';
import {addToDoList} from '../../../services/MadricService';
import Spinner from '../../Spinner/Spinner';
import {useParams} from 'react-router-dom';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function AddToDoList(props) {
  const [inputValue, setInputValue] = useState('');
  const [errors, setErrors] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {setProjectInfo} = useContext(MadricContext);
  const {id} = useParams();


  /**
   * Permet de submit le form de la todolist
   */
  async function handleSubmit() {
    if (inputValue === '' || inputValue === null) {
      setErrors('La description de la tâche ne peut pas être vide.');
    } else {
      setIsLoading(true);
      const res = await addToDoList(inputValue, id);
      props.closeModal();

      setProjectInfo((previous) => [res, ...previous].sort((a, b) => (a.complete === b.complete) ? 0 : a.complete ? 1 : -1));
      setIsLoading(false);
    }
  }


  return (
    <div>
      {isLoading && <Spinner />}
      <AddToDoListView
        inputValue={inputValue}
        setInputValue={setInputValue}
        closeModal={props.closeModal}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}

export default AddToDoList;
